import { useUpdateFeatures } from '@lopo-tech/frontends-shared'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { IRootState } from 'src/reducers/interface'
import { AuthenticationHelper } from 'src/utils/authentication/authentication'

export const FeatureConfig: React.FC = () => {
  const updateFeatureConfig = useUpdateFeatures()
  const hasToken = useSelector((state: IRootState) => state.user.hasToken)

  useEffect(() => {
    updateFeatureConfig(AuthenticationHelper.getAccessToken())
  }, [hasToken])

  return null
}
